import { render } from "./Zerocarbon.vue?vue&type=template&id=2a11feef&scoped=true"
import script from "./Zerocarbon.vue?vue&type=script&lang=js"
export * from "./Zerocarbon.vue?vue&type=script&lang=js"

import "./Zerocarbon.vue?vue&type=style&index=0&id=2a11feef&scoped=true&lang=scss"

import exportComponent from "D:\\work\\CodeV4\\FCP-Web-V4\\leanloop-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a11feef"]])

export default __exports__